var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "10.501 0 10.546 6 15 3.035"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.977,
    height: 1.514,
    y: 2.36
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-180 7.5 7.5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "10.501 0 10.546 6 15 3.035"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.977,
    height: 1.514,
    y: 2.36
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/Swap.95c5f1a8.svg";
export { ForwardRef as ReactComponent };